/** Shipped tester notes for Admin → Flow. Bilingual on purpose (walk was FR UI). */

export const FLOW_FILL = {
  f1: {
    must:
      "FR: Courriel d’approbation — FRONTEND_URL doit être l’URL lab/staging, pas localhost, hors machine locale.\nEN: Invite/set-password links must use the deployed FRONTEND_URL.\nFR: Landing reste EN alors que l’app est FR — soit harmoniser, soit l’accepter comme site marketing.\nEN: Public landing stayed English while the logged-in app was French.",
    nice:
      "FR: Pills EN/FR aussi sur /register (aujourd’hui seulement login / forgot).\nEN: EN/FR toggle on register, not only login/forgot.\nFR: Confirmation waitlist dans le classeur (état après Demander l’accès).\nEN: Capture the waitlisted confirmation screen in this flow.",
    notes:
      "Walk local 2026-09-25 (generic, not a named cohort).\nPublic: / landing « Transform advice into growth » · /register waitlist banner · Je suis… Fondateur/Conseiller/Accélérateur.\nAdmin waitlist: mode Sur invitation; ligne fake leftover alex.hec.flow1@test.tb (Accélérateur, HEC) — not lab seed.\nLab login: founder@test.tb / Test12345!\nResend vide → EMAIL stub logs.",
    steps: {
      "1.0":
        "FR: Landing marketing, CTA Book your first advisory session. Langue EN malgré tb_lang=fr.\nEN: Marketing only. Book-session CTA is not waitlist signup.",
      "1.1":
        "FR: Fake walk — ne pas soumettre (évite une autre ligne waitlist). Rôle par défaut Fondateur. Demander l’accès disabled tant que CGU + bêta non cochées.\nEN: Do not submit on lab if you want a clean waitlist. Consents gate the button.",
      "1.2":
        "FR: Rôle traduit (Accélérateur) OK. Donnée fake encore visible: Alex / alex.hec.flow1@test.tb.\nEN: Localized role OK. Pending row is leftover from an earlier waitlist test, not Maya/Camille seed.",
      "1.3":
        "FR: Template {name} générique. Local: pas d’inbox.\nEN: Preview only. 7-day token vs forgot-password 1 hour.",
      "1.4":
        "FR: Connexion FR. Mot de passe oublié = 1 h. Lab: founder@test.tb / Test12345! (même mot de passe cofounder / accelerator / coach).\nEN: Same. Admin is TractionBoard2026! not Test12345!.",
    },
  },
  f2: {
    must:
      "FR: Vérifier que le cofondateur (Jordan) voit le même graphe d’entreprise que Maya — pas re-testé ce passage.\nEN: Re-walk as cofounder@test.tb to confirm shared connections vs Maya.",
    nice:
      "FR: Capture communauté côté conseiller (Léa).\nEN: Advisor community screenshot missing.\nFR: Photo LinkedIn Eric vs initiales Léa/Tom — OK mais inégal.\nEN: Mixed photo vs initials in the same row.",
    notes:
      "Founder Maya: Mes connexions shows Eric de Gheldere (photo), Léa Moreau, Tom Berger.\nAccelerator Camille: advisors Eric / Léa / Tom in header Accélérateur.\nFake graph is Northstar Bio + Northstar Accelerator + Climara + Deep Signal — not a real cohort.",
    steps: {
      "2.1":
        "FR: Vue fondateur — Maya Chen · Northstar Bio · FONDATEUR. Connexions déjà seedées (pas besoin d’inviter).\nEN: Seed auto-connects Maya to coaches, accelerator, Eric, providers.",
      "2.2":
        "FR: Vue accélérateur — Camille Okonkwo · NORTHSTAR ACCELERATOR. Même page, autre header.\nEN: Same Community route; view pill is Accelerator.",
    },
  },
  f3: {
    must:
      "FR: Léa (coach@test.tb) a 0 réservation — le flux conseiller est vide. Seed une rencontre Maya↔Léa pour le lab.\nEN: Advisor bookings empty. Lab seed should include at least one Maya↔Léa (or Eric) advisory slot.\nFR: Date picker new session en mm/dd/yyyy alors que UI FR.\nEN: Datetime placeholder is US format in FR UI.",
    nice:
      "FR: Titre placeholder « Monthly advisory — Q2 » en anglais dans le formulaire FR.\nEN: Form placeholders not translated.\nFR: Recurrence weekly — pas exercé (créer vraiment).\nEN: Did not click Create on this pass.",
    notes:
      "Founder bookings: past 1:1s Maya↔Jordan (weekly cadence, hospital intros, open check-in) — fake Northstar data already in DB.\nNew session: Avec = Choisir la personne (connections exist).\nAccelerator Camille sees those teammate 1:1s as COLLÈGUE + AVANT LA RENCONTRE.\nAdvisor Léa: empty upcoming and past.",
    steps: {
      "3.1":
        "FR: Vue fondateur. Cartes passées avec Jordan Hale. CTA Planifier une rencontre / Réserver un mandat.\nEN: Fake data: weekly founder 1:1s already on Maya’s Bookings.",
      "3.2":
        "FR: Recurrence Ne se répète pas / Chaque semaine. Create disabled until person+time.\nEN: Did not submit a new fake meeting this pass.",
      "3.3":
        "FR: Vue accélérateur — voit les 1:1 collègues Northstar (Maya+Jordan) sans les avoir créés.\nEN: Observer/host view of connected-company meetings.",
      "3.4":
        "FR: Vue conseiller Léa — vide. Connexion existe côté accélérateur mais pas de booking avec Léa.\nEN: Seed gap: connect ≠ booked.",
    },
  },
  f4: {
    must:
      "FR: Le classeur ne montre que « Avant la rencontre ». Capturer notes live (tout le monde / accélérateur / privé) + after + résumé.\nEN: Missing screens: during notes visibilities, after form, transcript, AI summary.\nFR: Confirmer qu’une note privée Maya n’apparaît pas chez Camille.\nEN: Privacy of private notes vs accelerator not verified this pass.",
    nice:
      "FR: Seed « Victoires de la semaine » pour la rencontre d9f9afd7… (champs vides).\nEN: Before-form fields empty on the sample session.\nFR: Lien Meet placeholder seulement.\nEN: No real Meet URL on the fake session.",
    notes:
      "Opened as Maya: Rencontre avec Jordan Hale · mar. 22 sept. 14h · 30 min · Weekly 1:1.\nTabs Ma préparation / Sa préparation. Fake data: meeting exists, prep empty.\nSession id used: d9f9afd7-4ab9-4fcb-a915-2960348879c2.",
    steps: {
      "4.1":
        "FR: Vue fondateur sur un 1:1 collègue. En-tête FONDATEUR. Visibilité des notes non ouverte.\nEN: Same. Accelerator watching this meeting is flow 11.",
    },
  },
  f5: {
    must:
      "FR: Métriques lab à « — » (clients, ARR, trésorerie). Seed un instantané Northstar (ex. ARR 120k, 3 clients) sinon le portrait est vide.\nEN: Metrics/roadmap not submitted — advisors see nothing useful until Save & submit with numbers.\nFR: Document « bible test » = fichier fake local, pas un vrai deck.\nEN: Sample doc name is leftover test junk — rename in seed.",
    nice:
      "FR: Après Enregistrer & soumettre, capturer ce que voit Camille/Léa sur le même portfolio.\nEN: Missing the advisor/accelerator read-only snapshot view.",
    notes:
      "Maya Portfolio tabs: Métriques (empty) · Feuille de route (Étoile polaire empty) · Documents (bible test, 21 B, 2026-09-14).\nStatus: Pas encore soumise on metrics and roadmap.\nFake company: Northstar Bio.",
    steps: {
      "5.1":
        "FR: Vue fondateur. Quatre onglets. Pas de chiffres seedés.\nEN: Company picture is the structure only until someone types fake KPIs and submits.",
    },
  },
  f6: {
    must:
      "FR: Aucun mandat seedé. Créer un fake « Northstar Bio × Climara — GTM 90 jours » Maya↔Léa (proposed → accept) pour que le flux 6 soit cliquable.\nEN: Empty list — cannot walk accept/milestones without creating one.",
    nice:
      "FR: Capturer le formulaire + Nouveau mandat (choix conseiller = Léa / Eric).\nEN: Create-mandate form not in screenshots.",
    notes:
      "Walked as Maya: Planifier un mandat · empty state.\nFake to create: title « Advisory GTM Q4 », counterparty Léa Moreau (coach@test.tb), CAD, 0 = intro or 500000 cents.",
    steps: {
      "6.1":
        "FR: Vue fondateur, 0 mandat. CTA + Nouveau mandat visible.\nEN: Same empty state. Advisor Léa would also see 0 until proposed.",
    },
  },
  f7: {
    must:
      "FR: Pas de bug bloquant. Confirmer en session cofounder@test.tb que Jordan peut retirer son propre statut (bouton visible chez Maya sur Jordan).\nEN: Maya can « Retirer le statut de cofondateur » on Jordan — confirm that is intended.",
    nice:
      "FR: Walk + Inviter un coéquipier (courriel fake founder2@test.tb) — pas fait.\nEN: Invite-teammate email flow not exercised.",
    notes:
      "Team: Maya Chen PRINCIPAL + COFONDATEUR (founder@test.tb) · Jordan Hale COFONDATEUR (cofounder@test.tb).\nFake company workspace Northstar Bio. Copy explains Living Doc approvers.",
    steps: {
      "7.1":
        "FR: Vue fondateur. Seed lab déjà en place (pas besoin d’inviter Jordan).\nEN: Co-founder flag and shared access are the story here.",
    },
  },
  f8: {
    must:
      "FR: Native file picker « Choose File / No file chosen » reste EN dans UI FR.\nEN: Browser file input not localized.\nFR: Ne pas importer un CSV de prod sur lab — utiliser le modèle.\nEN: Import is live on lab DB; use template + fake rows only.",
    nice:
      "FR: Prefill textarea with 2 fake CSV rows (founder3@test.tb, coach3@test.tb) behind a « Coller l’exemple ».\nEN: Example paste button would make the flow demoable without a file.",
    notes:
      "Accelerator Camille · Gestion des données.\nFake CSV shape: name,email,role,company,program,cohort,year\nExample row: Alex Rivera,founder1@test.tb,entrepreneur,Rivera Health,Health & Bio,S26,2026\nDid not click Import this pass (would create real users).",
    steps: {
      "8.1":
        "FR: Vue accélérateur. Importer le CSV / Télécharger le modèle / Export fondateurs.\nEN: Template + export buttons visible. Import disabled until paste/file.",
    },
  },
  f9: {
    must:
      "FR: Northstar Bio apparaît deux fois — Maya en Sélectionné, Jordan en Anciens. Même entreprise / deux fondateurs = cartes séparées. Clarifier si c’est voulu.\nEN: One company, two founder cards in different stages is confusing for a funnel demo.",
    nice:
      "FR: Cliquer Northstar Bio → portfolio partagé (pas capturé).\nEN: Drill-in from funnel card missing from screenshots.",
    notes:
      "Camille portfolio Entreprises: Candidat 0 · Sélectionné Northstar Bio (Maya Chen) · Assigné 0 · Anciens Northstar Bio (Jordan Hale).\nFilters: Tous les fondateurs / conseillers / programmes Health & Bio / cohortes S26 / années 2026.\nFake programs already on seed: Health & Bio, Climate, Deep Tech.",
    steps: {
      "9.1":
        "FR: Vue accélérateur. Filtres + Modifier les étapes + Ajouter une entreprise.\nEN: This is the company funnel. Coach board is flow 10.",
    },
  },
  f10: {
    must:
      "FR: Pipeline personnel de Léa est vide (Prospect/Découverte/Actif/Anciens) alors qu’elle est Candidat sur le board accélérateur. Seed Northstar sur le pipeline conseiller.\nEN: Advisor funnel empty — demo gap vs accelerator coach board.",
    nice:
      "FR: Notes « Ajouter des notes » sur Tom/Eric pas ouvertes.\nEN: Coach-card notes UI not captured.",
    notes:
      "Accelerator coaches: Candidat Tom Berger (Deep Signal) + Léa Moreau (Climara) · Sélectionné Eric de Gheldere (Colectiv) · Assigné vide.\nAdvisor Léa portfolio: own kanban empty + hint to add from Community.",
    steps: {
      "10.1":
        "FR: Vue accélérateur — 2e kanban Coachs/Conseillers. Fake people: Tom, Léa, Eric.\nEN: Dual board is accelerator-only.",
      "10.2":
        "FR: Vue conseiller — autre produit (pipeline fondateurs perso). Stages Prospect/Découverte/Actif/Anciens.\nEN: Not the same as Camille’s coach funnel.",
    },
  },
  f11: {
    must:
      "FR: Non vérifié: notes visibilité=privé absentes chez Camille. À tester avec une note privée sur la rencontre Jordan.\nEN: Core promise of this flow not proven this pass — only that Camille lists the meetings.",
    nice:
      "FR: Ouvrir une carte depuis vue accélérateur (pas seulement la liste).\nEN: Click-through from accelerator Bookings into the session.",
    notes:
      "Same screenshot as 3.3. Camille sees 1:1 with Jordan Hale · 1:1 Maya·Jordan weekly · Northstar advisory (hospital intros / open check-in).\nBadges COLLÈGUE + AVANT LA RENCONTRE. Fake: she did not host these; seed connections expose them.",
    steps: {
      "11.1":
        "FR: Vue accélérateur. Liste = meetings des entreprises connectées.\nEN: Watch ≠ private. Need a private-note control test.",
    },
  },
  f12: {
    must:
      "FR: Bio Maya en anglais alors que UI FR (profil bilingue non branché à la langue UI).\nEN: Profile body stays EN; header/role are FR. Decide if localized_text should follow UI lang.",
    nice:
      "FR: Capturer fiche Léa / Eric / Camille (pas seulement Maya).\nEN: Missing advisor + accelerator profile screens.\nFR: Onglet rencontres du profil non capturé.\nEN: Meetings tab on profile not opened.",
    notes:
      "Maya Chen · Fondateur · Northstar Bio · CEO & founder · LinkedIn placeholder · bio EN about seed round.\nSettings → from profile. Fake LinkedIn slug maya-chen-northstar.",
    steps: {
      "12.1":
        "FR: Vue fondateur sur /app/u/f247ebb0-c004-4992-ab74-f5341c860cd5.\nEN: Header FONDATEUR is the view badge in-product.",
    },
  },
  f13: {
    must:
      "FR: « Partagées avec vous » vide. Pour un demo accélérateur, partager 1 méthodologie (ex. KTH) à Maya.\nEN: Library is system frameworks only — no shared-from-accelerator example.",
    nice:
      "FR: Walk build/import (/app/frameworks/build) — pas fait.\nEN: Builder not in screenshots.",
    notes:
      "Library fake/system: Cycle de vie des entreprises — Innovation technologique · KTH — Niveaux de maturité · MIT — Entrepreneuriat discipliné (partially in shot).\nFounder can browse; create is more advisor/accelerator.",
    steps: {
      "13.1":
        "FR: Vue fondateur. Méthodologies système visibles.\nEN: Good enough to show the catalog. Sharing is the gap.",
    },
  },
  f14: {
    must:
      "FR: Sous-titre « À venir » vs pastilles DISPONIBLE — copy contradictoire.\nEN: Toolbox subtitle says coming soon while cards are Available.\nFR: Pages solution Fireraven / LeChiffre pas ouvertes dans le classeur.\nEN: Offers seed exists (provider@fireraven.ai) but flow screenshot stops at toolbox tiles.",
    nice:
      "FR: Capturer /app/solutions/fireraven en vue fondateur.\nEN: Add offer detail screenshot next pass.",
    notes:
      "Boîte à outils: Méthodologies + Offres et services, both DISPONIBLE.\nFake providers on seed: Fireraven, LeChiffre. Password Test12345! for provider@…\nFounder Maya can open the catalog; did not open a solution page this pass.",
    steps: {
      "14.1":
        "FR: Vue fondateur. Deux tuiles. Pas le détail offre.\nEN: This is the doorway; seeded offers live behind Offres et services.",
    },
  },
  f15: {
    must:
      "FR: Journal/Brain pas activé sur founder@test.tb — le flux 15 n’est pas marchable en vue fondateur. Flag journal_enabled sur le seed Maya ou documenter « admin only ».\nEN: Founder cannot see Journal/Memory/Docs in nav. Screens are Admin view only.",
    nice:
      "FR: Seed 1 post journal fake + 1 living doc COMPANY pour que Memory ≠ empty.\nEN: Empty states only: Rien ici / Aucun document vivant.",
    notes:
      "Walked as admin@tractionboard.ai (journal always on).\nJournal empty composer · Memory 0 across Journal/Métriques/Feuille de route/Documents · Docs starter kit CTA.\nGated feature — not the core HEC weekly loop.",
    steps: {
      "15.1":
        "FR: Vue admin (pas fondateur). Nav Journal / Mémoire / Docs visible.\nEN: To demo as founder, enable journal on Maya in Admin → Users.",
    },
  },
  f16: {
    must:
      "FR: Nettoyer waitlist/users de test (camille.hec.flow1@test.tb, alex.hec.flow1@test.tb) ou les labelliser — ils polluent le lab générique.\nEN: Leftover named-cohort test accounts in Admin Users + Waitlist.\nFR: Ne pas basculer signup en Ouvert sur un lab partagé sans prévenir.\nEN: Signup mode is Invite-only on this walk — leave it unless you intend public register.",
    nice:
      "FR: Pastille Flow passe à la ligne sous les autres onglets — OK mobile, un peu orpheline desktop.\nEN: Flow pill wraps to second row.",
    notes:
      "Admin KPIs this walk: 14 users · WAU 1 · 10 sessions (9 scheduled / 1 completed) · 0 mandates · 16 connections · 0 feedback.\nUsers table: leftover Camille HEC accelerator + coach2 Tom · Journal/Brain disabled on those rows.\nWaitlist pending includes Alex HEC fake request.\nThis workbook: Admin → Flow. Notes = localStorage tb-flow-workbook-v2 this browser only.",
    steps: {
      "16.1":
        "FR: Vue admin. Onglets Vue d’ensemble / Utilisateurs / Liste d’attente / Flow.\nEN: Console is the operator loop for Get-in (flow 1.2) and journal flags (flow 15).",
    },
  },
};
